import styled from 'styled-components'

const MenuBarStyle = styled.div`
    position: absolute;
    display: flex;
    top: 20px;
    right: 20px;
`

export default MenuBarStyle